<template>
  <button :type="type" class="v-button-mts--v2" v-on="$listeners">
    <BaseButtonWithLoader :is-active="isLoading">
      <div class="v-button-mts--v2__content">
        <slot></slot>
      </div>
    </BaseButtonWithLoader>
  </button>
</template>

<script>
import BaseButtonWithLoader from '@/components/NewDesign/Common/Base/Button/BaseButtonWithLoader.vue'

export default {
  name: 'VButtonMTSV2',
  components: { BaseButtonWithLoader },
  props: {
    type: {
      type: String,
      default: 'button',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.v-button-mts--v2 {
  position: relative;
  display: flex;
  justify-content: center;
  width: auto;
  border: none;
  background: none;
  font-family: $font-mts-wide;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  text-decoration: none;
  color: $color-dark-2;
  text-align: center;
  outline: none;
  overflow: hidden;
  transition: all 0.275s ease;
  cursor: pointer;

  &__content {
    display: flex;
    align-items: center;
  }

  & > * {
    position: relative;
    z-index: 3;
  }
  &[class*='gradient'] {
    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all 0.275s ease;
    }
  }
  &.--white {
    background: $color-white;
    @include hover-focus-active {
      background: rgba(255, 255, 255, 0.9);
    }
  }

  &.--grey {
    background: $color-gray-2;
    @include hover-focus-active {
      background: #e5e7ed;
    }
  }

  &.--black {
    background: $color-dark-3;
    color: $color-light;
    @include hover-focus-active {
      background: #231c29;
    }
  }

  &.--violet-gradient {
    color: $color-white;
    &::before {
      background: linear-gradient(93.12deg, #8743dd -0.17%, #9666fb 151.36%);
    }
    @include hover-focus-active {
      &::after {
        background: #8151dd;
        opacity: 1;
        transition: all 0.275s ease;
        z-index: 2;
      }
    }
  }

  &.--xl {
    font-size: 14px;
    line-height: 20px;
    border-radius: 20px;
    padding: 24px;

    &::v-deep span {
      padding: 2px 8px;
    }
  }

  &.--l {
    font-size: 12px;
    line-height: 16px;
    border-radius: 16px;
    padding: 14px;

    &::v-deep span {
      padding: 4px 8px;
    }
  }

  &.--m {
    font-size: 12px;
    line-height: 16px;
    border-radius: 16px;
    padding: 10px;

    &::v-deep span {
      padding: 4px 8px;
    }
  }

  &.--s {
    font-size: 10px;
    line-height: 12px;
    border-radius: 12px;
    padding: 8px;

    &::v-deep span {
      padding: 2px 4px;
    }

    &::v-deep .button-loader__spinner svg {
      width: 16px;
      height: 16px;
    }
  }

  &::v-deep span {
    display: inline-block;
  }
}
</style>
